export const mapTypesButtons = [
  {
    type: 'location',
    label: 'Location',
  },
  {
    type: 'event',
    label: 'Incidents',
  },
  {
    type: 'datachain',
    label: 'DataChain',
  },
  {
    type: 'risk',
    label: 'Risk',
  },
];

export const flowLegendConfig = {
  total: {
    label: 'Total Subjects',
  },
  tierOne: {
    label: 'Tier-1 Suppliers',
  },
  scp: {
    label: 'Supply Chain Participants',
  },
  mineSites: {
    label: 'Mine Sites',
  },
  linked: {
    label: 'Linked',
  },
  unlinked: {
    label: 'Unlinked',
  },
};

export const listTypesButtons = [
  {
    type: 'supplyChainParticipants',
    label: 'Supply Chain Participants',
  },
  {
    type: 'supplyChainLocations',
    label: 'Supply Chain Locations',
  },
];

export const getTabs = (t) => [
  {
    key: 'flow',
    label: t('Flow'),
  },
  {
    key: 'map',
    label: t('Map'),
  },
];

export const renderLevel = (data = {}, key) => {
  if (data[key]) {
    if (typeof data[key] === 'string') {
      return data[key];
    }
    if (data[key].name && typeof data[key].name === 'string') {
      return data[key].name;
    }
  }

  if (data.exportTown && data.exportTown[key] && data.exportTown[key] !== 'N/A') {
    return data.exportTown[key];
  }

  return '-';
};
